import { autoserialize } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

export class LyftDispatchRideType extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
